import { render, staticRenderFns } from "./AdminReportSellerActivity.vue?vue&type=template&id=31843b90"
import script from "./AdminReportSellerActivity.vue?vue&type=script&lang=js"
export * from "./AdminReportSellerActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gl-api/api.greenlists.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('31843b90')) {
      api.createRecord('31843b90', component.options)
    } else {
      api.reload('31843b90', component.options)
    }
    module.hot.accept("./AdminReportSellerActivity.vue?vue&type=template&id=31843b90", function () {
      api.rerender('31843b90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/pages/AdminReportSellerActivity.vue"
export default component.exports